module.exports = __webpack_public_path__ + "static/email-template-password-reset-4150fb045228380fa15dac12ab3d1423.jpg";